/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Pizza(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M144,156a27.9931,27.9931,0,0,1,49.13477-18.35474l26.11962-41.04492a144.01914,144.01914,0,0,0-182.50878,0l21.15918,33.25025A27.99977,27.99977,0,1,1,84,168c-.62646,0-1.24561-.02808-1.86182-.06836L121.251,229.394a8,8,0,0,0,13.49853,0l29.5708-46.46924A28.00554,28.00554,0,0,1,144,156Z"
        opacity={0.2}
      />
      <Path
        d="M23.44054,75.69239a8.02578,8.02578,0,0,1,2.13281-10.834,176.07221,176.07221,0,0,1,204.85329,0,8.02577,8.02577,0,0,1,2.13281,10.834L134.74929,229.394a8,8,0,0,1-13.49858,0Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M36.74566,96.60039a144.01884,144.01884,0,0,1,182.50866,0"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M164.31747,182.93292a28.00353,28.00353,0,1,1,28.82269-45.29368"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M57.89918,129.84281A28.00328,28.00328,0,1,1,84,168q-.91436,0-1.81448-.05785"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default Pizza;
